/**
 * the value representing Toggle option for {@link Toggle | Toggle Component}
 */
export enum ToggleState {
  Dollar = '$',
  Percentage = '%',
}
